import { Paper, Typography } from "@mui/material";
import { t } from "i18next";
import WorkerPieChart from "./WorkerPieChart";
import { useSelector } from "react-redux";

function ReportPiewChart({ allServices }) {
    const { currentLanguage } = useSelector((state) => state.translationReducer);
  
  return (
    <Paper sx={{ borderRadius: "6px", p: 1, height: 400 }}>
      <Typography variant="h5" fontWeight={600} p={2}>
        {t("totalServices")}
      </Typography>
      {allServices?.length > 0 ? (
        <WorkerPieChart data={allServices} currentLanguage={currentLanguage}/>
      ) : (
        <Typography
          variant="h6"
          fontWeight={600}
          my={2}
          textAlign={"center"}
          p={2}
        >
          {t("noDataFound")}
        </Typography>
      )}
    </Paper>
  );
}

export default ReportPiewChart;
